// extracted by mini-css-extract-plugin
export default {"modal":"theme_modal__KybbY","input":"theme_input__jEThC","type":"theme_type__r3CK0","actions":"theme_actions__rHe+c"};